// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__xuy5w","cell":"ColumnAccessor_cell__1hNzk","firstCellAccent":"ColumnAccessor_firstCellAccent__OMu0j"};